import { addDays, addQuarters, addYears, format } from 'date-fns';

const formatDate = (date) => {
  return format(date, 'yyyy-MM-dd');
};
const generatedDates = {
  week() {
    return formatDate(addDays(Date.now(), -7));
  },
  month() {
    return formatDate(addDays(Date.now(), -30));
  },
  quarter() {
    return formatDate(addQuarters(Date.now(), -1));
  },
  year() {
    return formatDate(addYears(Date.now(), -1));
  },
  now() {
    return formatDate(Date.now());
  },
  day() {
    return formatDate(Date.now());
  }
};

export { generatedDates };
